import { createContext, useContext, useEffect, useState } from 'react'
import { supabase, getUserHousehold } from '../lib/supabase'

const AuthContext = createContext(null)

export function AuthProvider({ children }) {
  const [user, setUser]           = useState(null)
  const [household, setHousehold] = useState(null)
  const [loading, setLoading]     = useState(true)

  const loadHousehold = async (u) => {
    if (!u) return setHousehold(null)
    const hh = await getUserHousehold(u.id)
    setHousehold(hh)
  }

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setUser(session?.user ?? null)
      loadHousehold(session?.user ?? null).finally(() => setLoading(false))
    })
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_e, session) => {
      setUser(session?.user ?? null)
      loadHousehold(session?.user ?? null)
    })
    return () => subscription.unsubscribe()
  }, [])

  const refreshHousehold = () => loadHousehold(user)

  return (
    <AuthContext.Provider value={{ user, household, loading, refreshHousehold }}>
      {children}
    </AuthContext.Provider>
  )
}

export const useAuth = () => useContext(AuthContext)
